import { render, staticRenderFns } from "./PlacementEventsList.vue?vue&type=template&id=bec296e8"
import script from "./PlacementEventsList.vue?vue&type=script&lang=js"
export * from "./PlacementEventsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports